import { ButtonNavigationBack } from "@nova/component-btn"
import { VideoColorFinderFlight } from "@nova/protobuf"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { ColorfinderVideoReferenceProcessing } from "./ColorfinderVideoReferenceProcessing"
import { ColorfinderVideoSelection } from "./ColorfinderVideoSelection"
import {
    selectActiveFeatureId,
    selectActiveLayerId,
    setActiveFeatureId,
    setActiveLayerId,
} from "panels/content/side-panel/slice.new"
import { selectEntityById } from "panels/content/side-panel/slice"
import Image from "next/image"
import { useRef } from "react"

export const ColorfinderCreateFromLayer = ({ flight }: { flight: VideoColorFinderFlight }) => {
    const dispatch = useAppDispatch()

    const activeLayerId = useAppSelector(selectActiveLayerId)
    const entity = useAppSelector(selectEntityById(activeLayerId || ""))
    const activeFeatureId = useAppSelector(selectActiveFeatureId)
    const abortControllerRef = useRef(new AbortController())

    return (
        <>
            <ButtonNavigationBack
                title={"Back"}
                onClick={() => {
                    // if (!uploads?.length && !job) dispatch(deleteFlight({ id: flightId }))
                    dispatch(setActiveLayerId({ id: undefined }))
                    dispatch(setActiveFeatureId({ feature: undefined }))
                }}
                className="self-start"
            />
            {activeLayerId && activeFeatureId && (
                <div className="flex gap-2 items-center mt-3 mb-4">
                    <div className="h-6 w-6 shrink-0">
                        <Image
                            src="/images/plugins/layers/colorfinder.svg"
                            alt="Colorfinder"
                            width={24}
                            height={24}
                            className="w-full h-full object-contain"
                            priority
                        />
                    </div>
                    <h4 className="text-gray-0 overflow-hidden whitespace-nowrap text-ellipsis">
                        {`Create ${entity.name}`}
                    </h4>
                </div>
            )}
            {flight.referenceVideoId && (
                <ColorfinderVideoReferenceProcessing
                    onDelete={() => abortControllerRef.current.abort()}
                    flight={flight}
                />
            )}
            {!flight.referenceVideoId && (
                <ColorfinderVideoSelection abortController={abortControllerRef.current} />
            )}
        </>
    )
}
